module.exports = __webpack_public_path__ + "media/images/steps/svg/233-curriculum-1-86b4c20bc8145ea64e2a13fffad55b95.svg";